import React, { InputHTMLAttributes, ReactNode, useState } from 'react';

import * as S from './styles';

export type InputProps = {
  label?: string;
  error?: string;
  icon?: ReactNode | null;
  iconRight?: ReactNode | null;
  isValid?: boolean;
  isNotValid?: boolean;
  clickOnIcon?: () => void;
} & InputHTMLAttributes<HTMLInputElement>;

const Input = ({
  clickOnIcon = () => {
    /**/
  },
  error,
  icon = null,
  label,
  value,
  onFocus: componentOnFocus,
  onBlur: componentOnBlur,
  iconRight,
  isValid,
  isNotValid,
  ...props
}: InputProps) => {
  const [isFocus, setFocus] = useState(false);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') e.preventDefault();
  };

  return (
    <S.Container>
      <S.InputWrapper isFocus={isFocus} isValid={!!isValid} isNotValid={!!isNotValid}>
        {label && value && (
          <S.Label isFocus={isFocus} isValid={!!isValid} isNotValid={!!isNotValid}>
            {label}
          </S.Label>
        )}
        {!!icon && <S.IconWrapper onClick={() => clickOnIcon()}>{icon}</S.IconWrapper>}
        <S.CustomInput
          value={value}
          {...props}
          icon={!!icon}
          iconRight={!!iconRight}
          onKeyDown={handleKeyDown}
          onFocus={e => {
            setFocus(true);
            if (componentOnFocus) {
              componentOnFocus(e);
            }
          }}
          onBlur={e => {
            setFocus(false);
            if (componentOnBlur) {
              componentOnBlur(e);
            }
          }}
        />
        {!!iconRight && <S.IconWrapper onClick={() => clickOnIcon()}>{iconRight}</S.IconWrapper>}
      </S.InputWrapper>
      {error && <small className="error-message">{error}</small>}
    </S.Container>
  );
};
export default Input;
